const config = {
    apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:8000',
    apiVersion: process.env.REACT_APP_API_VERSION || 'v1',
    uploadMaxSize: parseInt(process.env.REACT_APP_UPLOAD_MAX_SIZE) || 5242880, // 5MB default
};

// Define subjects with Vietnamese labels
export const SUBJECTS = {
    math: 'Toán',
    literature: 'Ngữ Văn',
    english: 'Tiếng Anh',
    physics: 'Vật lý',
    chemistry: 'Hóa học',
    // biology: 'Sinh học',
    history: 'Lịch sử',
    geography: 'Địa lý',
    civic_education: 'GD kinh tế PL',
    technology: 'Công nghệ công nghiệp',
    computer_science: 'Tin học'
};

export const PRINCIPAL_SUBJECTS = {
    math: 'Toán',
    physics: 'Vật lý',
    chemistry: 'Hóa học',
    english: 'Tiếng Anh',
    literature: 'Ngữ Văn',
    computer_science: 'Tin học'
};

export const GRADES = [10, 11, 12];

export const admissionAreaGuide = {
    "KV1": {
        label: "Khu vực 1 (KV1)",
        description: "Các xã vùng đồng bào dân tộc thiểu số và miền núi, xã khu vực I, II, III; các xã có thôn vùng đồng bào dân tộc thiểu số và miền núi, thôn đặc biệt khó khăn; các xã/phường hải đảo/đặc khu; các xã/phường biên giới đất liền.",
        color: "blue"
    },
    "KV2-NT": {
        label: "Khu vực 2 nông thôn (KV2-NT)",
        description: "Các địa phương không thuộc KV1, KV2, KV3 (hầu hết các xã, thị trấn nông thôn thông thường).",
        color: "green"
    },
    "KV2": {
        label: "Khu vực 2 (KV2)",
        description: "Các phường thuộc tỉnh; các xã của thành phố trực thuộc Trung ương (trừ các xã thuộc KV1).",
        color: "yellow"
    },
    "KV3": {
        label: "Khu vực 3 (KV3)",
        description: "Các phường của thành phố trực thuộc Trung ương (Hà Nội, TP.HCM, Hải Phòng, Đà Nẵng, Cần Thơ).",
        color: "red"
    }
};

export const admissionPolicyGuide = {
    group1: {
        title: "Nhóm 1 (ưu tiên cao hơn)",
        items: [
            {
                code: "01",
                description: "Công dân Việt Nam là người dân tộc thiểu số được hưởng ưu tiên khu vực 1"
            },
            {
                code: "02",
                description: "Thương binh, bệnh binh, người hưởng chính sách như thương binh; quân nhân, công an xuất ngũ hoàn thành nghĩa vụ"
            },
            {
                code: "03",
                description: "Thân nhân liệt sĩ; con thương binh/bệnh binh suy giảm ≥81%; con người nhiễm chất độc da cam suy giảm ≥81%; con Anh hùng LLVTND/Anh hùng Lao động thời kháng chiến; con nhiễm chất độc da cam đang hưởng trợ cấp hàng tháng"
            }
        ]
    },
    group2: {
        title: "Nhóm 2",
        items: [
            {
                code: "04",
                description: "Thanh niên xung phong tập trung được cử đi học; quân nhân/công an tại ngũ ≥15 tháng được cử đi học"
            },
            {
                code: "05",
                description: "Người dân tộc thiểu số học ngoài KV1; con thương binh/bệnh binh suy giảm <81%; con nhiễm chất độc da cam suy giảm <81%"
            },
            {
                code: "06",
                description: "Người khuyết tật nặng; giáo viên đã dạy đủ 3 năm (dự tuyển ngành sư phạm); y tá, điều dưỡng, y sĩ… đã công tác đủ 3 năm (dự tuyển đúng ngành sức khỏe)"
            }
        ]
    }
};

export default config; 